import { render, staticRenderFns } from "./PropertyProfileComponent.vue?vue&type=template&id=35fb46ba"
import script from "./PropertyProfileComponent.vue?vue&type=script&lang=js"
export * from "./PropertyProfileComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports